import { render } from "./house-8.vue?vue&type=template&id=242d5b20"
import script from "./house-8.vue?vue&type=script&lang=js"
export * from "./house-8.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__